import {FormSectionType} from "../../@types/forTestingFormSectionsResources.ts";
import {
    handleNumericField,
    handlePhonePrefix,
    handleWebsite,
    removeSpaces
} from "../../helpers/register-form/registerFormHelper.tsx";
import {GatewayServiceEnum} from "../../enum/registration/GatewayServiceEnum.ts";

export const AcceptPaymentsPageFormSectionsNotRegisteredConfig: FormSectionType[] = [
    {
        heading: 'e_shop_information',
        rows: [
            {
                inputs: [
                    {
                        label: 'website_address_of_store',
                        registerLabel: 'web_protocol',
                        required: false,
                        isSelect: true,
                        selectOptions: [
                            {
                                name: 'http://'
                            },
                            {
                                name: 'https://'
                            }
                        ],
                        secondInput: {
                            registerLabel: 'website_url',
                            required: false,
                            type: 'text',
                            onchange: (e) => removeSpaces(e),
                            onblur: (e) => handleWebsite(e.target, GatewayServiceEnum.WEBSITE_ALLOWED_FOR_REGISTER),
                        },
                        hint: 'example_website_address_of_store',
                        onchange: () => {}
                    },
                    {
                        label: 'website_phone_number',
                        registerLabel: 'website_phone_number_prefix',
                        required: false,
                        type: 'tel',
                        initialValue: '+370',
                        pattern: '.{2,}',
                        maxLength: 4,
                        secondInput: {
                            registerLabel: 'website_phone_number',
                            required: false,
                            type: 'tel',
                            maxLength: 16,
                            onchange: (e) => handleNumericField(e),
                        },
                        hint: 'example_phone_number',
                        onchange: (e) => handlePhonePrefix(e)
                    }
                ]
            },
            {
                inputs: [
                    {
                        label: 'website_email',
                        registerLabel: 'website_email',
                        required: false,
                        type: 'email',
                        hint: 'example_email_address',
                        singleInput: true,
                        onchange: () => {},
                    },
                    {
                        label: 'website_name',
                        registerLabel: 'unregistered_website_name',
                        required: false,
                        type: 'text',
                        hint: 'example_website_name',
                        singleInput: true,
                        onchange: () => {},
                    },
                ]
            },
            {
                inputs: [
                    {
                        label: 'website_description',
                        registerLabel: 'unregistered_website_description',
                        required: false,
                        type: 'textarea',
                        hint: 'example_website_description',
                        singleInput: true,
                        onchange: () => {},
                    }
                ]
            }
        ]
    },
    {
        heading: 'installer_information',
        rows: [
            {
                inputs: [
                    {
                        label: 'name',
                        registerLabel: 'installer_name',
                        required: false,
                        type: 'text',
                        singleInput: true,
                        onchange: () => {},
                    },
                    {
                        label: 'surname',
                        registerLabel: 'installer_surname',
                        required: false,
                        type: 'text',
                        singleInput: true,
                        onchange: () => {},
                    }
                ]
            },
            {
                inputs: [
                    {
                        label: 'email',
                        registerLabel: 'installer_email',
                        required: false,
                        type: 'email',
                        hint: 'example_installer_email',
                        singleInput: true,
                        onchange: () => {},
                    }
                ]
            }
        ]
    }
]
